import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { TabMenuTabModel } from '../../../shared-components/tab-menu/tab-menu.component';

@Component({
  selector: 'app-admin-coupons',
  templateUrl: './coupons.component.html',
  styleUrl: './coupons.component.scss',
  standalone: false,
})
export class AdminCouponsComponent implements OnDestroy, OnInit {
  public isLoading = true;
  public activeTab: 'promo-codes' | 'sellable-codes' | 'coupon-usage' =
    'promo-codes';
  public tabs: TabMenuTabModel[] = [
    {
      key: 'promo-codes',
      label: 'Promo Codes',
      iconClass: 'fa-envelope-open-dollar',
    },
    {
      key: 'sellable-codes',
      label: 'Verkaufbare Codes',
      iconClass: 'fa-cart-shopping',
    },
    {
      key: 'coupon-usage',
      label: 'Gutscheinkontrolle',
      iconClass: 'fa-ticket',
    },
  ];
  public promoCodes: any[] = [];
  public sellableCodes: any[] = [];
  public couponUsageLogs: any[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params['tab']) {
          this.activeTab = params['tab'];
        }
      });
  }

  public onTabChange(tab: TabMenuTabModel): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        tab: tab.key,
      },
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
